import { isIOSNativeApp, isAndroidNativeApp } from "#/lib/carrot-api/MobileNativeClient"
import { Box } from "@carrotfertility/carotene-core"
import React from "react"
import appStoreBadgeSrc from "#/features/sprints-landing/assets/images/app-store-badge.svg"
import googlePlayBadgeSrc from "#/features/sprints-landing/assets/images/google-play-badge.svg"
import { SPRINTS_MESSAGES } from "#/features/sprints-landing/en-only-text"

export const SPRINTS_APP_STORE_URL = "https://apps.apple.com/app/id6740922917"
export const SPRINTS_GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.getcarrot.sprints"

function AppStoreButton() {
  return (
    <Box
      component="a"
      href={SPRINTS_APP_STORE_URL}
      sx={(theme) => ({
        borderRadius: theme.tokens.borderRadius.md,
        blockSize: "fit-content"
      })}
      aria-label={SPRINTS_MESSAGES.downloadButtons.iosAriaLabel}
    >
      <Box component="img" src={appStoreBadgeSrc} alt="" />
    </Box>
  )
}

function GooglePlayButton() {
  return (
    <Box
      href={SPRINTS_GOOGLE_PLAY_URL}
      component="a"
      sx={(theme) => ({
        borderRadius: theme.tokens.borderRadius.md,
        blockSize: "fit-content"
      })}
      aria-label={SPRINTS_MESSAGES.downloadButtons.googlePlayAriaLabel}
    >
      <Box component="img" src={googlePlayBadgeSrc} alt="" />
    </Box>
  )
}

export function DownloadButtons() {
  if (isIOSNativeApp()) {
    return [<AppStoreButton key="app-store" />]
  }
  if (isAndroidNativeApp()) {
    return [<GooglePlayButton key="google-play" />]
  }
  return [<GooglePlayButton key="google-play" />, <AppStoreButton key="app-store" />]
}
